import { render, staticRenderFns } from "./KegMiniDashboardModal.vue?vue&type=template&id=b8420850&scoped=true"
import script from "./KegMiniDashboardModal.vue?vue&type=script&lang=js"
export * from "./KegMiniDashboardModal.vue?vue&type=script&lang=js"
import style0 from "./KegMiniDashboardModal.vue?vue&type=style&index=0&id=b8420850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8420850",
  null
  
)

export default component.exports